import { __assign, __rest } from "tslib";
import React, { useRef, useState, useEffect, useMemo } from "react";
import { TextField, makeStyles, Popover } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import ArrowDropIcon from "@material-ui/icons/ArrowDropDown";
import MaskedInput from "react-text-mask";
import { useConfigs } from "../config-provider";
import List from "./List";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    icon: {
      marginRight: 16
    },
    dropdown: {
      cursor: "pointer"
    }
  };
});

function TextMaskCustom(props) {
  var inputRef = props.inputRef,
      other = __rest(props, ["inputRef"]);

  return React.createElement(MaskedInput, __assign({}, other, {
    ref: function ref(_ref) {
      inputRef(_ref ? _ref.inputElement : null);
    },
    mask: [/\d/, /\d/, ":", /\d/, /\d/, " ", /[A|P|a|p]/, /[M|m]/],
    placeholderChar: "\u2000",
    showMask: true
  }));
}

function getTime(hour, minutes) {
  return "".concat(String(hour >= 12 ? hour - 12 : hour).padStart(2, "0"), ":").concat(String(minutes).padStart(2, "0"), " ").concat(hour >= 12 ? "PM" : "AM");
}

var TimeList = function TimeList(_a) {
  var label = _a.label,
      options = _a.options,
      inputValue = _a.value,
      onChange = _a.onChange;
  var locale = useConfigs().locale;
  var classes = useStyles();
  var textRef = useRef(null);

  var _b = useState(false),
      open = _b[0],
      setOpen = _b[1];

  var _c = useState(inputValue || null),
      value = _c[0],
      setValue = _c[1];

  var _d = useState(""),
      errMsg = _d[0],
      setErrMsg = _d[1];

  var _e = useState(1),
      refresh = _e[1];

  useEffect(function () {
    refresh(0);
  }, []);
  var textValue = useMemo(function () {
    return value ? getTime(value.hours(), value.minutes()) : "";
  }, [value]);

  function handleChange(v) {
    setOpen(false);
    setValue(v.value);
    onChange && onChange(v.value);
  }

  function handleBlur(e) {
    var value = e.target.value;

    if (value.replace(/:/, "").replace(/\s+/, "") === "") {
      onChange && onChange(null);
      return;
    }

    var times = value.split(" ");
    var hour = parseInt(times[0].split(":")[0]);
    var minute = parseInt(times[0].split(":")[1]);

    if (!Number.isFinite(hour) || !Number.isFinite(minute) || hour >= 24 || minute >= 60) {
      setErrMsg(locale.DateRange.invalidDate);
      onChange && onChange(null);
      return;
    }

    var day = String(times[1]).toUpperCase();
    var now = moment();
    now.hours(hour > 11 ? hour : day === "PM" ? hour + 12 : hour);
    now.minutes(minute);
    setValue(now);
    onChange && onChange(now);
  }

  return React.createElement(React.Fragment, null, React.createElement(TextField, {
    label: label,
    variant: "outlined",
    size: "small",
    ref: textRef,
    value: textValue,
    onBlur: handleBlur,
    error: Boolean(errMsg),
    onChange: function onChange() {
      return setErrMsg("");
    },
    helperText: errMsg,
    InputProps: {
      inputComponent: TextMaskCustom,
      startAdornment: React.createElement(AccessTimeIcon, {
        fontSize: "small",
        color: "action",
        className: classes.icon
      }),
      endAdornment: React.createElement(ArrowDropIcon, {
        color: "action",
        onClick: function onClick() {
          return setOpen(true);
        },
        className: classes.dropdown
      })
    }
  }), open && textRef && textRef.current && React.createElement(Popover, {
    open: true,
    anchorEl: textRef.current,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    onClose: function onClose() {
      return setOpen(false);
    }
  }, options.length === 0 ? locale.DateRange.noData : React.createElement(List, {
    options: options,
    // selected={selected ? selected.value : ""}
    onChange: handleChange
  })));
};

export default TimeList;